/**
 * Represents a ProductInStore component
 *
 * @module views/components/ProductInStore
 * @memberof -Common
 */
import './ProductInStore.scss';

import React from 'react';

import PropTypes from 'prop-types';

import AsyncComponent from '@ulta/core/components/AsyncComponent/AsyncComponent';

import { CheckStoreAvailability } from '@ulta/modules/ProductActions/ProductActions';
import Tag from '@ulta/modules/Tag/Tag';



/**
 * Represents a ProductInStore component
 *
 * @method
 * @param { ProductInStoreProps} props - React properties passed from composition
 * @returns ProductInStore
 */
export const ProductInStore = function( props ){

  const {
    inStore,
    storeAvailabilityAction,
    config,
    id,
    invokeMutation,
    addToBagAction,
    addToBagErrorLabel,
    commerceId,
    inBagLabel,
    incrementBagAccessibilityLabel,
    maxQuantity,
    productId,
    quantity,
    removeFromBagAction,
    skuId,
    successLabel,
    updateBagAction,
    bookmarkAction,
    bookmarked,
    removeBookmarkAction,
    state } = props;
  if( !inStore ){
    return null;
  }

  return (
    <div className='ProductInStore'>
      <div className='ProductInStore__Container'>
        <div className='ProductInStore__Container--AddToBag'>
          { addToBagAction && (
            <AsyncComponent
              id={ id }
              invokeMutation={ invokeMutation }
              addToBagAction={ addToBagAction }
              addToBagErrorLabel={ addToBagErrorLabel }
              commerceId={ commerceId }
              default={ props.default }
              inBagLabel={ inBagLabel }
              incrementBagAccessibilityLabel={ incrementBagAccessibilityLabel }
              key='AddToBagButton'
              maxQuantity={ maxQuantity }
              moduleName='AddToBagButton'
              productId={ productId }
              quantity={ quantity }
              removeFromBagAction={ removeFromBagAction }
              skuId={ skuId }
              state={ state }
              successLabel={ successLabel }
              updateBagAction={ updateBagAction }
            /> ) }
          <div className='ProductInStore__tag'>
            <Tag
              variant='utility'
              style='notification'
              message={ inStore?.inStoreOnlyLabel }
            />
            <div>
              <CheckStoreAvailability
                storeAvailabilityAction={ storeAvailabilityAction }
                config={ config }
              />
            </div>
          </div>
        </div>
        <div className='ProductInStore__Container--Favorite'>
          <AsyncComponent
            id={ id }
            invokeMutation={ invokeMutation }
            bookmarkAction={ bookmarkAction }
            bookmarked={ bookmarked }
            commerceId={ commerceId }
            key='ProductBookmark'
            moduleName='ProductBookmark'
            productActionsProps={ props }
            productId={ productId }
            quantity={ quantity }
            removeBookmarkAction={ removeBookmarkAction }
            skuId={ skuId }
            state={ state }
          />
        </div>
      </div>
    </div>
  );
};

/**
 * Property type definitions
 * @typedef ProductInStoreProps
 * @type {object}
 * @property {string} example - refactor or delete
 */
export const propTypes =  {
  inStore: PropTypes.shape( { inStoreOnlyLabel: PropTypes.string } ),
  storeAvailabilityAction: PropTypes.object,
  config: PropTypes.object,
  id: PropTypes.string,
  invokeMutation: PropTypes.func,
  bookmarkAction: PropTypes.object,
  bookmarked: PropTypes.bool,
  commerceId: PropTypes.string,
  productId: PropTypes.string,
  quantity: PropTypes.string,
  removeBookmarkAction: PropTypes.object,
  skuId: PropTypes.string,
  state: PropTypes.string
};


ProductInStore.propTypes = propTypes;

export default ProductInStore;
